import React from 'react';

import { PhoneProviderContext } from '@app/components/UI/PhoneProvider/PhoneProvider';

const InvalidFamily: React.FC = () => {
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>Thank you for trusting us with your pet’s care.</p>
					<p>
						To provide you with the best support during this time, please call us at
						{' '}
						<span className="inline-block">
							<a href={contextPhone.state.phoneNumberHref} className="inline-link">
								{contextPhone.state.phoneNumberDisplay}
							</a>
						</span>
						{' '}
						to book your appointment.
					</p>
					<p>We are here to guide you through every step.</p>
				</div>
			</div>
		</div>
	);
};

export default InvalidFamily;
